import type { OnboardingStep } from './types'

/** Étape du tour "org-read-guided-pdl" où seul le clic sur la carte PDL doit rester possible. */
const PDL_CARD_STEP_ID = 'national-pdl-card'

/** Index des étapes (2, 5, 6) où les boutons dans l’élément Driver actif doivent être bloqués. */
const STEP_INDEXES_WITH_BLOCKED_BUTTONS = [1, 4, 5]

export function shouldActivatePdlClickLock(step: OnboardingStep | undefined, currentPath: string): boolean {
  return step?.id === PDL_CARD_STEP_ID && !currentPath.startsWith('/PDL')
}

export function shouldBlockButtonsAtStep(stepIndex: number): boolean {
  return STEP_INDEXES_WITH_BLOCKED_BUTTONS.includes(stepIndex)
}
